import React from 'react';
import Layout from '../components/layout/Layout';
import Hero from '../components/home/Hero';
import TrustIndicators from '../components/home/TrustIndicators';
import CorporateIntro from '../components/home/CorporateIntro';
import BrandsSection from '../components/home/BrandsSection';
import FeaturedServices from '../components/home/FeaturedServices';
import FeaturedProject from '../components/home/FeaturedProject';
import SiesaAppSection from '../components/home/SiesaAppSection';
import WhyChooseUs from '../components/home/WhyChooseUs';
import SectorsSection from '../components/home/SectorsSection';
import QuoteCallToAction from '../components/ui/QuoteCallToAction';
import { organizationSchema, localBusinessSchema, webSiteSchema, jsonLd } from '../lib/seo';

export default function Home() {
  return (
    <Layout
      title="Soluciones e Integraciones Eléctricas S.A. | Panamá"
      description="Especialistas en diseño, suministro, instalación, automatización y mantenimiento de sistemas eléctricos de baja y media tensión en Panamá."
      seoChildren={
        <>
          <script type="application/ld+json">{jsonLd(organizationSchema())}</script>
          <script type="application/ld+json">{jsonLd(localBusinessSchema())}</script>
          <script type="application/ld+json">{jsonLd(webSiteSchema())}</script>
        </>
      }
    >
      <Hero />
      <TrustIndicators />
      <CorporateIntro />
      <BrandsSection />
      <FeaturedServices />
      <FeaturedProject />
      <SiesaAppSection />
      <WhyChooseUs />
      <SectorsSection />
      <QuoteCallToAction />
    </Layout>
  );
}
